import { useEffect as c } from "react";
const o = ({
  id: t,
  zIndex: a
}) => {
  c(() => {
    const n = `${t}-DatePickerCalendarStyles`, r = document.getElementById(n);
    r && r.remove();
    const e = document.createElement("style");
    return e.id = n, e.innerHTML = `#${t}-datePickerCalendar .react-datepicker { z-index: ${a || "auto"} }`, document.getElementsByTagName("head")[0].appendChild(e), () => {
      e.remove();
    };
  }, [t, a]);
};
export {
  o as default
};
